// extracted by mini-css-extract-plugin
module.exports = {"SaveElectricD":"D_SaveElectricD__TJobJ"};